import { AxiosInstance } from 'axios';
import { result, Result } from 'util/result';
import FileService from '../FileService';
import { UploadFileResponse } from '../../../../data/terra/api/file/response/UploadFileResponse';

class FileEndpoint {
  getUploadFileUrl = () =>
    `${FileService.FILE_SERVICE_HOST}/upload/image?cloud=true`;
}

export class FileApi {
  fileClient: AxiosInstance;
  endpoint = new FileEndpoint();

  constructor(client: AxiosInstance) {
    this.fileClient = client;
  }

  uploadImage(data: FormData): Promise<Result<UploadFileResponse>> {
    return result(
      async () =>
        (
          await this.fileClient.post<UploadFileResponse>(
            this.endpoint.getUploadFileUrl(),
            data
          )
        ).data
    );
  }
}
